import { getEnvVars } from '@order/utils';

export const { ADJUST_APP_TOKEN, ADJUST_ENVIRONMENT } = getEnvVars();
export const CUSTOMER_ID_PARAMETER = 'customer_user_id';
export const ATT_CONSENT_WAITING_INTERVAL = 120;
